import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import WhatsAppButton from "./components/WhatsAppButton";
import "./styles/Home.css";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    const hideEmergentBadge = () => {
      const allElements = document.querySelectorAll('a, div, span, iframe, button');
      allElements.forEach((el) => {
        const text = el.textContent?.toLowerCase() || '';
        const href = el.getAttribute('href')?.toLowerCase() || '';
        if (
          (text.includes('made with') && text.includes('emergent')) ||
          (text.includes('emergent') && el.tagName === 'A' && href.includes('emergent')) ||
          (el.id && el.id.toLowerCase().includes('emergent-badge'))
        ) {
          el.style.display = 'none';
          el.style.visibility = 'hidden';
          el.style.opacity = '0';
          el.style.pointerEvents = 'none';
          el.style.position = 'fixed';
          el.style.zIndex = '-9999';
        }
      });
    };

    hideEmergentBadge();
    const interval = setInterval(hideEmergentBadge, 1000);
    const observer = new MutationObserver(hideEmergentBadge);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      clearInterval(interval);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <WhatsAppButton />
    </div>
  );
}

export default App;
